import React, { useState,useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './LoginForm';
import Layout from './Layout';
import Home from './components/Home';
import Setting from './components/Setting';
import ViewData from './components/ViewData';
import MandatoryInfo from './components/MandatoryInfo';
import Organization from './components/organization/Organization';
import OrganizationForm from './components/organization/OrganizationForm';
import OrganizationDetail from './components/organization/OrganizationDetail';
import User from './components/user/User';
import UserForm from './components/user/UserForm';
import ProfileForm from './components/profile/ProfileForm';
import HomeNew from './components/HomeNew';

// <----- ProtectedRoute component to check authentication ----->
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated } = useAuth();
//   return isAuthenticated ? children : <Navigate to="/" />;
// };

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <div></div>;
  }
  return isAuthenticated ? children : <Navigate to="/" />;
};

const AdminRoute = ({ children }) => {
  const { userDetails, isLoading } = useAuth();
  if (isLoading) return <div></div>;
  const isAdmin = userDetails?.admin === true;
  return isAdmin ? children : <Navigate to="/home" replace />;
};

function App() {

  const [openDropdown, setOpenDropdown] = useState(null); 
  const dropdownRefs = useRef({});
  const [isOffcanvasVisible, setIsOffcanvasVisible] = useState(null);

  // for handling dropdowns
  const toggleHandleDropdown = (dropdownName) => {
    console.log(dropdownName);
      setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));   
  };

  const getDropdownRef = (key) => {
    if (!dropdownRefs.current[key]) {
      dropdownRefs.current[key] = React.createRef(); 
    }
    return dropdownRefs.current[key];
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const isClickInsideAnyDropdown = Object.values(dropdownRefs.current).some((ref) =>
        ref.current?.contains(event.target)
      );
      if (!isClickInsideAnyDropdown) {
        setOpenDropdown(null); 
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  //for handling offcanvas
  const toggleOffcanvas = (offcanvasName) => {
      console.log(offcanvasName);
      setIsOffcanvasVisible((prev) => (prev === offcanvasName ? null :offcanvasName));   
  };

  const handleBackdropClick = (e) => {
    console.log("Backdrop clicked", e.target.className); 
      if (e.target.className === 'backdrop') {
          setIsOffcanvasVisible(false);
      }
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/home" element={<Home toggleHandleDropdown={toggleHandleDropdown} openDropdown={openDropdown} getDropdownRef={getDropdownRef}/>} />
             <Route path="/home-new" element={<HomeNew toggleHandleDropdown={toggleHandleDropdown} openDropdown={openDropdown} getDropdownRef={getDropdownRef}/>} />
            <Route path="/user" element={<AdminRoute><User/></AdminRoute>}/>
            <Route path="/add-user" element={<AdminRoute><UserForm isEditing={false} toggleHandleDropdown={toggleHandleDropdown} openDropdown={openDropdown} getDropdownRef={getDropdownRef}/></AdminRoute>} />
            <Route path="/edit-user/:userid" element={<AdminRoute><UserForm isEditing={true} toggleHandleDropdown={toggleHandleDropdown} openDropdown={openDropdown} getDropdownRef={getDropdownRef}/></AdminRoute>} />
            <Route path="/view-data" element={<ViewData toggleOffcanvas={toggleOffcanvas} isOffcanvasVisible={isOffcanvasVisible} handleBackdropClick={handleBackdropClick}/>} />
            {/* Settings and Mandatory Info are available to all authenticated users.
                Admins see all countries; non-admins are restricted to their own country in the API. */}
            <Route path="/settings" element={<Setting isEditing={false}/>} />
            <Route path="/settings/:countryId" element={<Setting isEditing={true}/>} />
            <Route path="/mandatory-info" element={<MandatoryInfo />} />
            <Route path="/organization" element={<Organization />} />
            <Route path="/add-organization-info" element={<OrganizationForm isEditing={false}/>} />
            <Route path="/edit-organization-info/:orgId" element={<OrganizationForm isEditing={true}/>} />
            <Route path="/view-organization-info/:orgId" element={<OrganizationDetail />} />
            <Route path="/profile" element={<ProfileForm toggleOffcanvas={toggleOffcanvas} isOffcanvasVisible={isOffcanvasVisible} handleBackdropClick={handleBackdropClick}/>}/>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;